import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = m[1];
    const intended_role = localStorage.getItem("qld_intended_role") || undefined;
    (async () => {
      try {
        const { data } = await api.post("/auth/google/complete", { session_id, intended_role });
        localStorage.removeItem("qld_intended_role");
        setUser(data);
        const dest = data.role === "admin" ? "/dashboard/admin"
                    : data.role === "vendor" ? "/dashboard/vendor"
                    : "/dashboard/lovers";
        navigate(dest, { replace: true });
      } catch (e) {
        setErr("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="text-center">
        <div className="text-coral text-sm tracking-[0.22em] uppercase mb-3">Finishing up</div>
        <div className="font-serif text-3xl text-ink">Welcoming you in…</div>
        {err && <p className="mt-6 text-destructive text-sm">{err}</p>}
      </div>
    </div>
  );
}
